import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Benefits from './components/Benefits';
import EquipmentCatalog from './components/EquipmentCatalog';
import Plans from './components/Plans';
import FAQ from './components/FAQ';
import ContactForm from './components/ContactForm';
import MapSection from './components/MapSection';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import './index.css';

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Services />
      <Benefits />
      <EquipmentCatalog />
      <Plans />
      <FAQ />
      <ContactForm />
      <MapSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;
